import React, { useEffect, useState } from "react";

const RevertControl = ({
  show,
  loading,
  isSaving,
  isReverting,
  revertError,
  onRevert,
}) => {
  const [showRevertConfirm, setShowRevertConfirm] = useState(false);

  useEffect(() => {
    if (revertError) {
      setShowRevertConfirm(false);
    }
  }, [revertError]);

  useEffect(() => {
    if (!show) {
      setShowRevertConfirm(false);
    }
  }, [show]);

  if (!show) {
    return null;
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setShowRevertConfirm(true)}
        disabled={loading || isSaving || isReverting}
        className="rounded-lg border border-rose-500/40 bg-rose-500/10 px-3 py-2 text-xs font-semibold text-rose-100 transition-colors hover:border-rose-400 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
      >
        Revert to original
      </button>

      {showRevertConfirm ? (
        <div className="absolute right-0 top-full z-30 mt-2 w-[min(20rem,calc(100vw-2rem))] rounded-2xl border border-slate-700 bg-slate-950 p-4 text-left shadow-[0_18px_50px_rgba(2,6,23,0.7)]">
          <h3 className="text-sm font-semibold text-slate-50">Revert to original?</h3>
          <p className="mt-2 text-sm leading-6 text-slate-300">
            This will delete the current edited version and restore the original document
            in the collection.
          </p>
          <div className="mt-4 flex flex-wrap justify-end gap-2">
            <button
              type="button"
              onClick={() => setShowRevertConfirm(false)}
              disabled={isReverting}
              className="rounded-lg border border-slate-700 bg-slate-900 px-3 py-2 text-xs font-semibold text-slate-200 transition-colors hover:border-slate-500 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={async () => {
                try {
                  await onRevert?.();
                  setShowRevertConfirm(false);
                } catch {
                  // Parent surfaces revert failures.
                }
              }}
              disabled={isReverting}
              className="rounded-lg border border-rose-500/40 bg-rose-500/10 px-3 py-2 text-xs font-semibold text-rose-100 transition-colors hover:border-rose-400 hover:text-white disabled:cursor-not-allowed disabled:opacity-40"
            >
              {isReverting ? "Reverting..." : "Revert"}
            </button>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default RevertControl;
